import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core";
import React from "react";
import amazonLogo from '../../assets/logo/amazon_ColorFull_logo.png';
import airbnbLogo from '../../assets/tracks/airbnb.svg';
import appleLogo from '../../assets/tracks/apple.svg';
import facebookLogo from '../../assets/tracks/facebook.svg';
import googleLogo from '../../assets/tracks/google.svg';
import microsoftLogo from '../../assets/tracks/microsoft.svg';
import netflixLogo from '../../assets/tracks/netflix.svg';
import uberLogo from '../../assets/tracks/uber.svg';
import { useState } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            gap: '3rem',
        },
        display: 'flex',
        gap: '5rem',
        flexDirection: 'column',
        width: '100%',
    },
    contentContainer: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column'
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    partnerCompanies: {
        gap: '1.5rem',
        '& h1': {
            flexBasis: '40%'
        },
        '& div': {
            flexBasis: '50%'
        }
    },
    checkPointsContainer: {
        display: 'flex',
        gap: '1rem',
        alignItems: 'baseline',
        flexWrap: 'wrap',
    },
    responsiveImg: {
        width: '100%'
    },
    tickContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '5px',
        width: '2rem',
        height: '2rem',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    },
    companiesImages: {
        flexGrow: 2,
        '& div': {
            [theme.breakpoints.down("xs")]: {
                gap: '1.5rem'
            },
            display: 'flex',
            margin: '1rem 0',
            justifyContent: 'space-around',
            gap: '2rem'
        },
        '& img': {
            width: '5rem',
        }
    },
    contentWithImageContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        width: '350px',
        padding: '1rem',
        height: '5rem',
    }
}))

const PartnerCompanies = () => {

    const classes = useStyles();

    const companiesLogo = [
        [airbnbLogo, amazonLogo, uberLogo, microsoftLogo],
        [appleLogo, googleLogo, facebookLogo, netflixLogo]
    ]

    return (
        <div className={`${classes.contentContainer} ${classes.partnerCompanies}`}>
            <h1>1500+  companies in our network</h1>
            <div className={classes.companiesImages}>
                {
                    companiesLogo.map((companiesArr, idx) => (
                        <div key={idx + 'main-array'}>
                            {companiesArr.map((company, idx) => (
                                <img src={company} key={idx + 'company-logos'} />
                            ))}
                        </div>
                    )
                    )
                }
            </div>
        </div>
    )
}

const TickIconWithText = ({ fillColor, text, ...props }) => {
    const classes = useStyles();

    return (
        <div className={`${classes.contentWithImageContainer} ${props.lightBoxShadowForPills}`}>
            <div className={classes.tickContainer} style={{ background: fillColor }}>
                <FontAwesomeIcon icon={faCheck} />
            </div>
            <h4>{text}</h4>
        </div>
    )
}

const AboutTheCourse = ({ landingPageInfo, keyPoints, ...props }) => {

    const classes = useStyles();
    const [keyPointsForTrack, setKeyPointsForTrack] = useState([]);

    useEffect(() => {
        setKeyPointsForTrack(prepareKeyPoints())
    }, [keyPoints])

    const prepareKeyPoints = () => {
        if (!keyPoints) {
            return;
        }
        const tickColors = ['#C1CEF2', '#ADD8E6', '#FEEA8F', '#FFB8C0', '#A4A4EA'];
        return keyPoints.map((keyPoint, idx) => {
            return { bgFillColor: tickColors[idx % 5], text: keyPoint.value }
        })
    }

    return (
        <>
            <section className={`${classes.root}`}>
                <PartnerCompanies />
                <div className={`${classes.contentContainer} ${props.textInfoContainers}`}>
                    <div className={classes.mainContent}>
                        <h1>{landingPageInfo?.heading}</h1>
                        <p>{landingPageInfo?.subHeading}</p>
                    </div>
                    <div>
                        <img src={landingPageInfo?.image} className={classes.responsiveImg} />
                    </div>
                </div>
                {keyPointsForTrack?.length > 0 &&
                    <div>
                        <h1>What you will learn</h1>
                        <div className={classes.checkPointsContainer}>
                            {
                                keyPointsForTrack.map((val, idx) => {
                                    return (<TickIconWithText fillColor={val.bgFillColor} text={val.text} key={idx + val.text} {...props} />);
                                })
                            }
                        </div>
                    </div>}
            </section>
        </>
    )
}

export default AboutTheCourse;